<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";

export default {
  name: "MaterialFieldsPathway",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },
    /**
     * Different installation type options
     */
    installationTypeOptions: {
      type: Array,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      /**
       * Array with for the different surface type options for the users to choose
       */
      surfaceTypeOptions: [],
      /**
       * Array with for the different pathway type options for the users to choose
       */
      pathwayTypeOptions: []
    };
  },

  /**
   * Executed when the component is mounted
   * Loads the options for the lists and does a preemptive verification
   *
   */
  mounted() {
    this.loadListOptions();
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.tc("Pathway", 1) + ' ' + this.$i18n.tc("Type", 1),
          value: !this.editingData
            ? this.parseSelectValue(this.familySpecificFields.pathway_type, this.pathwayTypeOptions)
            : this.familySpecificFields.pathway_type,
          varName: 'pathway_type',
          inputType: 'multiselect',
          disabled: false,
          required: true,
          options: this.pathwayTypeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("InstallationType"),
          value: !this.editingData
            ? this.parseSelectValue(this.familySpecificFields.installation_type, this.installationTypeOptions)
            : this.familySpecificFields.installation_type,
          varName: 'installation_type',
          inputType: 'multiselect',
          disabled: false,
          options: this.installationTypeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.tc("Surface", 1) + ' ' + this.$i18n.tc("Type", 1),
          value: !this.editingData
            ? this.parseSelectValue(this.familySpecificFields.surface_type, this.surfaceTypeOptions)
            : this.familySpecificFields.surface_type,
          varName: 'surface_type',
          inputType: 'multiselect',
          disabled: false,
          options: this.surfaceTypeOptions,
          clearable: true,
          size: '100%'
        },
      ]
    },
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.pathway_type &&
        this.familySpecificFields.pathway_type.length > 0
      );
    },

    /**
     * Loads the pathway and surface type options and assigns them to the attributes pathwayTypeOptions and surfaceTypeOptions
     */
    async loadListOptions() {
      try {
        this.pathwayTypeOptions = await this.GET_LIST({
          listName: "list_implantation_type",
          code:
            this.material &&
            this.material.family_specific_fields &&
            this.material.family_specific_fields.pathway_type
              ? this.material.family_specific_fields.pathway_type
              : []
        });
        this.surfaceTypeOptions = await this.GET_LIST({
          listName: "list_surface_type",
          code:
            this.material &&
            this.material.family_specific_fields &&
            this.material.family_specific_fields.surface_type
              ? this.material.family_specific_fields.surface_type
              : []
        });
      } catch (error) {
        console.error(error);
        this.pathwayTypeOptions = [];
        this.surfaceTypeOptions = [];
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsPathway.vue